import React, { useState } from 'react';
import { uploadImage, STORAGE_PATHS } from '../../services/firebase-storage.js';
import { API } from '../../utils/database-frontend.js';

const ServiceForm = ({ onSuccess, onError }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    image: null
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    setFormData(prev => ({
      ...prev,
      image: e.target.files[0]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.title || !formData.description || !formData.image) {
      onError('❌ Lütfen tüm alanları doldurun');
      return;
    }

    setLoading(true);
    
    try {
      // Upload image to Firebase Storage
      const uploadResult = await uploadImage(
        formData.image,
        STORAGE_PATHS.SERVICES,
        `service-${Date.now()}.${formData.image.name.split('.').pop()}`
      );

      // Add to PostgreSQL database
      const serviceData = {
        Title: formData.title,
        Description: formData.description,
        ImageUrl: uploadResult.url,
        FirebaseImagePath: uploadResult.path
      };

      await API.services.create(serviceData);
      
      onSuccess('✅ Hizmet başarıyla eklendi!');
      
      // Reset form
      setFormData({
        title: '',
        description: '',
        image: null
      });
      
      // Reset file input
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) fileInput.value = '';
      
    } catch (error) {
      onError('❌ Hizmet eklenirken hata oluştu: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2 className="text-lg font-semibold mb-4">🔧 Yeni Hizmet Ekle</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Hizmet Başlığı
          </label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
            placeholder="Örn: Beton Pompa Hizmeti"
            required
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Hizmet Açıklaması
          </label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleInputChange}
            rows="4"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
            placeholder="Hizmet hakkında detaylı açıklama..."
            required
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Hizmet Görseli
          </label>
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
            required
          />
          {formData.image && (
            <p className="mt-2 text-sm text-gray-600">
              Seçilen dosya: {formData.image.name}
            </p>
          )}
        </div>
        
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-green-600 text-white py-2 px-4 rounded-md hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed transition duration-300"
        >
          {loading ? '⏳ Ekleniyor...' : '✅ Hizmet Ekle'}
        </button>
      </form>
    </div>
  );
};

export default ServiceForm; 